import React, { Component } from "react";
import { Formik } from "formik";
import { server } from "../../../constants";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormInput,
  FormSelect
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import { getAllLocations } from "../../../actions/other_info/location.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import Moment from "react-moment";
import moment from "moment";
import MomentUtils from "@date-io/moment";
import Autosuggest from "react-autosuggest";
import { MuiPickersUtilsProvider, DatePicker } from "material-ui-thai-datepickers";
import { Button, Empty } from 'antd';
import {
  CloseOutlined
} from '@ant-design/icons';

class MeetingUserView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      userDetail: '',
      meetings: [],
      meetingDisplay: [],
      locations: [],
      suggestions: [],
      title: '',
      location: '',
      creator: '',
      meetingDate: null
    };

    this.token = localStorage.getItem("token");
    this.userDetail = localStorage.getItem("user_profile") ? JSON.parse(localStorage.getItem("user_profile")) : null
  }

  async componentDidMount() {
    await this.props.getAllLocations()
    this.setState({locations: this.props.locationsReducer.locations || []})
    
    if(this.token)  {
      this.setState({loading: true})

      try {
        const response = await httpClient.get(`api/meetings/user/email/${this.userDetail.email}`, {})

        this.setState({
          meetings: response.data,
          meetingDisplay: response.data
        })
      } catch(err)  {
        console.log(err)
      }
      
      this.setState({loading: false})
    } else {
      this.props.history.push(`/`)
    }
  }

  async titleFilter(value)  {
    await this.setState({title: value})
    this.filterMeeting()
  }

  async locationFilter(value)  {
    await this.setState({location: value})
    this.filterMeeting()
  }

  async creatorFilter(value)  {
    await this.setState({creator: value})
    this.filterMeeting()
  }

  async dateFilter(value)  {
    await this.setState({meetingDate: value ? value.toDate() : null})
    this.filterMeeting()
  }

  async locationFiler(value)  {
    await this.setState({location: value})
    this.filterMeeting()
  }

  filterMeeting() {
    const meetings = JSON.parse(JSON.stringify(this.state.meetings))
    let meetingList = meetings

    if(this.state.title)  {
      meetingList = meetingList.filter(item => {
        return item.title.includes(this.state.title)
      })
    }

    if(this.state.location)  {
      meetingList = meetingList.filter(item => {
        return item.location == this.state.location
      })
    }

    if(this.state.meetingDate)  {
      meetingList = meetingList.filter(item => {
        return moment(this.state.meetingDate).isSame(item.meetingStart, 'day');
      })
    }

    this.setState({meetingDisplay: meetingList})
  }

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: this.state.meetings,
    });
  };

  onSuggestionSelected = (
    event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    this.setState({
      title: suggestion.title
    });
  };

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const result = this.state.meetings.filter((meeting) =>
      inputLength !== 0
        ? meeting.title.toLowerCase().includes(inputValue)
        : true
    );

    if (inputLength === 0) {
      this.setState({
        meetingName: ''
      });
    }

    return result;
  };

  renderSuggestion = (suggestion) => suggestion.title;

  shouldRenderSuggestions() {
    return true;
  }

  getSuggestionValue = (suggestion) => suggestion.title;

  onMeetingNameChange = async (event, { newValue }) => {
    await this.setState({title: newValue});
    this.filterMeeting()
  };

  render() {
    const { title, suggestions } = this.state;

    const inputProps = {
      placeholder: "พิมพ์ชื่อการประชุม",
      value: title,
      onChange: this.onMeetingNameChange,
    };

    return (
      <div className="container">
        <Card className="my-5">
          <CardBody>  
            <div className="d-flex align-items-center">
              <div className="flex-fill">
                <h5 className="font-weight-bold mb-1">{ this.userDetail.displayName }</h5> 
                <p className="text-muted mb-0">หน่วยงาน: {this.userDetail.departmentName}</p>
              </div>
              <Button 
                type="primary" 
                onClick={() => {
                  localStorage.removeItem(server.LOGIN_PASSED);
                  localStorage.removeItem("user_profile");
                  this.props.appReducer.app.forceUpdate();
                  this.props.history.push(`/`)
                }}
              >
                ออกจากระบบ
              </Button>
            </div>

            <hr />

            <Row form className="mt-5">
              <Col md="6" className="form-group">
                <label>ชื่อการประชุม</label>
                <Autosuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  shouldRenderSuggestions={this.shouldRenderSuggestions}
                  onSuggestionSelected={this.onSuggestionSelected}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={inputProps}
                />
              </Col>
              <Col md="3" className="form-group">
                <div className="d-flex align-items-center mb-2">
                  วันที่ประชุม <CloseOutlined className="ml-2" onClick={() => this.dateFilter(null)} />
                </div>
                <MuiPickersUtilsProvider utils={MomentUtils} locale={'th'}>
                  <DatePicker
                    label=""
                    format="DD/MM/YYYY"
                    pickerHeaderFormat="DD/MM/YYYY"
                    value={this.state.meetingDate}
                    yearOffset={543}
                    okLabel="ตกลง"
                    autoOk={true}
                    className="d-flex w-100"
                    cancelLabel="ยกเลิก"
                    clearable={true}
                    onChange={(value) => {
                      this.dateFilter(value)
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Col>
              <Col md="3" className="form-group">
                <label>ชื่อผู้สร้างการประชุม</label>
                <FormInput
                  name="creator"
                  id="creator"
                  onChange={(e) => {
                    this.creatorFilter(e.target.value)
                  }}
                  value={this.state.creator}
                />
              </Col>
              <Col md="12" className="form-group">
                <label>สถานที่ประชุม</label>
                <FormSelect
                  name="location"
                  id="location"
                  onChange={(e) => this.locationFilter(e.target.value)}
                  value={this.state.location}
                >
                  <option value=""></option>
                  {this.state.locations.map((location) => {
                    return (
                      <option value={location.id} key={location.id}>
                        {location.name}
                      </option>
                    );
                  })}
                </FormSelect>
              </Col>
            </Row>

            { 
              this.state.meetingDisplay.length > 0 ?
              <table className="table table-bordered mt-4 border">
                <thead>
                  <tr>
                    <th>หัวข้อการประชุม</th>
                    <th className="text-center">ครั้งที่</th>
                    <th className="text-center">วันที่</th>
                    <th className="text-center">เวลา</th>
                    <th className="text-center">แก้ไข/ลบ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.meetingDisplay.map((meeting, index) => {
                    return (
                      <tr key={meeting.id}>
                        <td className="text-left align-middle">{meeting.title}</td>
                        <td className="text-center align-middle">
                          {meeting.sequence}/
                          <Moment format="YYYY" add={{ years: 543 }}>{meeting.meetingStart}</Moment>
                        </td>
                        <td className="text-center align-middle">
                          <Moment format="DD/MM/YYYY" add={{ years: 543 }}>{meeting.meetingStart}</Moment>
                        </td>
                        <td className="text-center align-middle">
                          <Moment format="HH:mm">{meeting.meetingStart}</Moment> -{" "}
                          <Moment format="HH:mm">{meeting.meetingEnd}</Moment>
                        </td>
                        <td className="text-center align-middle">
                          <a
                            type="button"
                            className="btn btn-xs btn-primary text-white"
                            href={"/meeting/report/" + meeting.id}
                          >
                            รายงานการประชุม
                          </a>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table> :
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ไม่พบข้อมูลการประชุม" className="mt-4"/>
            }
          </CardBody>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({ 
  appReducer,
  meetingReducer,
  locationsReducer
}) => ({
  appReducer, 
  meetingReducer,
  locationsReducer
});

const mapDispatchToProps = {
  ...actions,
  getAllLocations
};

export default connect(mapStateToProps, mapDispatchToProps)(MeetingUserView);
